import styled from "styled-components";
import Button from "../../components/utils/Button/Button";

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 8px;
`;
export const SvgContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const BackButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.075px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-top: 16px;
  margin-left: -7px;
  opacity: 0.5;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
`;

export const ModelTitle = styled.h1`
  color: #fff;
  font-family: Figtree;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.1px;
`;
export const ModelTitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  max-height: 24px;
`;

export const SelectContainer = styled.div`
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;
  max-width: 300px;
  display: flex;
  cursor: pointer;
  height: 44px;
  width: 100%;
  padding: 12px;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const ModelDescription = styled.h3`
  font-family: Figtree;
  color: #fff;
  font-size: 14;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const ModelColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  width: 100%;
`;

export const Tag = styled.div`
  display: flex;
  height: 24px;
  padding: 6px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: 8px;
  border: 1px solid #345884;
  background: #112238;
`;

export const TagText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px; /* 150% */
  letter-spacing: -0.06px;
  opacity: 0.7;
`;

export const ModelRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: baseline;
  }
`;
export const CollectionRow = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  width: 100%;

  @media (max-width: 1224px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  @media (max-width: 950px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
`;

export const LineHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const Line = styled.div`
  display: flex;
  border-radius: 100px;
  background: #325682;
  height: 2px;
  max-height: 2px;
  flex: 1 0 0;
`;

export const LineText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.24px;
`;

export const TextArea = styled.textarea`
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  display: flex;
  width: 100%;
  padding: 12px;
  align-items: flex-start;
  gap: 10px;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  max-width: 640px;
  letter-spacing: -0.21px;
  line-height: 1.5;

  resize: vertical;
  min-height: 100px;

  &:focus {
    outline: none;
    border-color: #2877d9;
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const FormInput = styled.input`
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  display: flex;
  width: 100%;
  max-width: 640px;
  min-height: 44px;
  padding: 12px;
  align-items: center;
  gap: 10px;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.21px;

  &:focus {
    outline: none;
    border-color: #2877d9;
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

export const ThinText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 300;
  line-height: 17px;
  letter-spacing: -0.21px;
  opacity: 0.5;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  width: 100%;
  flex-wrap: wrap;
`;

export const DescriptionRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ModelStatus = styled.div``;

export const StatusBadge = styled.span`
  background: rgba(255, 193, 7, 0.2);
  color: #ffc107;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ConfigSection = styled.div`
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;

  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
`;

export const SectionTitle = styled.h3`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.09px;
`;

export const TutorialLink = styled.button`
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  display: inline-flex;
  padding: 12px;
  align-items: center;
  gap: 10px;

  cursor: pointer;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

export const FormSection = styled.div`
  margin-bottom: 32px;
`;

export const LabelUpload = styled.label`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.09px;
`;

export const TextInput = styled.input`
  border-radius: 8px;
  border: none;
  outline: none;
  background: transparent;

  display: flex;
  height: 24px;
  /* width: 150px; */
  align-items: center;
  gap: 10px;
  align-self: stretch;

  color: #fff;
  font-family: Figtree;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const RequirementsSection = styled(ConfigSection)``;

export const RequirementTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "white")};
  margin: 0 0 24px 0;
`;

export const RequirementText = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.21px;
  opacity: 0.5;
  max-width: 324px;
`;

export const TextLight = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;

  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.21px;
  opacity: 0.5;
`;

export const Text = styled.li`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;

  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.21px;
  opacity: 0.8;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-left: 20px;
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  width: 100%;
`;

export const UploadCount = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.195px;

  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: 100px;
  border: 1px solid #4d8dff;
  background: #0d1a2e;
`;

export const CostSection = styled.div`
  background: ${({ theme }) =>
    theme === "light" ? "rgba(67, 233, 123, 0.05)" : "rgba(67, 233, 123, 0.1)"};
  border: 1px solid rgba(67, 233, 123, 0.3);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
  text-align: center;
`;

export const CostTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "white")};
  margin: 0 0 16px 0;
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 8px;
`;

export const OriginalPrice = styled.span`
  font-size: 32px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: line-through;
`;

export const UploadSection = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;
`;

export const UploadCard = styled.div`
  border-radius: 16px;
  border: 1px dashed #414143;
  padding: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: rgba(255, 255, 255, 0.035);
  }
`;

export const UploadCard2 = styled.div`
  display: flex;
  height: 176px;
  padding: 44px 4px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 12px;
  border: 1px dashed #315480;
  background:
    linear-gradient(0deg, #142743 0%, #142743 100%),
    url(<path-to-image>) lightgray 50% / cover no-repeat;
`;

export const UploadDescriptionText = styled.span`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 15px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  letter-spacing: -0.408px;
  opacity: 0.5;
`;

export const LabelRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;
export const UploadText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: ${(props) => (props.$light ? "13px" : "18px")};
  font-weight: ${(props) => (props.$light ? 300 : 500)};
  line-height: ${(props) => (props.$light ? "18px" : "normal")};
  margin-top: ${(props) => (props.$light ? "-12px" : "0px")};
  opacity: ${(props) => (props.$light ? 0.56 : 1)};
  letter-spacing: ${(props) => (props.$light ? "0" : "-0.408px")};

  cursor: pointer;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 32px;
  border-top: 1px solid
    ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)"};
`;

export const DeleteButton = styled(Button)``;

export const StartTrainingButton = styled.button`
  border-radius: 100px;
  background: #fff;
  display: flex;
  width: 186px;
  height: 44px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border: none;
  outline: none;

  cursor: pointer;
  color: #000;
  font-family: Figtree;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.08px;

  transition: all 0.3s ease-in-out;

  &:hover {
    transform: translateY(-2px);
  }
`;

export const FilePreviewGrid = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
  @media (max-width: 700px) {
    align-self: center;
    flex-direction: column;
    flex-wrap: unset;
  }
`;

export const FilePreviewItem = styled.div`
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  aspect-ratio: 1;
  background: #142743;
  border: 1px solid #325682;
  max-width: 170px;
  max-height: 220px;
  min-width: 170px;
  min-height: 220px;
`;

export const FilePreview = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  svg {
    width: 40px;
    height: 40px;
    color: #fff;
    opacity: 0.5;
  }
`;

export const RemoveFileButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 0, 0, 0.8);
  }
`;

export const FileName = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  color: #fff;
  font-size: 10px;
  padding: 8px 4px 4px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PageLoader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 20px;
`;

export const LoaderText = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.08px;
  opacity: 0.7;
`;
export const SkeletonLoaderColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const SkeletonLoader = styled.div`
  background: linear-gradient(90deg, #152a47 0px, #23406a 40px, #152a47 80px);
  background-size: 300px 100%;
  animation: shimmer 8s infinite linear;
  border-radius: ${(props) => props.$radius || "8px"};
  height: ${(props) => props.$height || "20px"};
  width: ${(props) => props.$width || "100%"};

  @keyframes shimmer {
    0% {
      background-position: -300px 0;
    }
    100% {
      background-position: 300px 0;
    }
  }
`;

export const SkeletonSection = styled.div`
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;
  padding: 16px;
  display: flex;
  height: ${(props) => props.$height || "335px"};
  max-height: ${(props) => props.$height || "335px"};
  flex-direction: column;
  gap: 16px;
  flex: 1 0 0;
`;

export const Label = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: -0.21px;
`;

export const Value = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const SmallRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 4px;
`;
